import React from "react";
import { View, StyleSheet } from "react-native";
import SkeletonBox from "./SkeletonBox";

const TenantCardSkeleton = () => {
  return (
    <View style={styles.card}>
      <SkeletonBox width={160} height={20} style={{ marginBottom: 10 }} />
      <SkeletonBox width={"60%"} height={16} style={{ marginBottom: 6 }} />
      <SkeletonBox width={"40%"} height={16} style={{ marginBottom: 12 }} />

      <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 12 }}>
        <SkeletonBox width={26} height={26} style={{ borderRadius: 13, marginRight: 10 }} />
        <SkeletonBox width={100} height={16} />
      </View>

      <SkeletonBox width={120} height={36} style={{ borderRadius: 20, marginBottom: 12 }} />

      <SkeletonBox width={"100%"} height={14} style={{ marginBottom: 6 }} />
      <SkeletonBox width={"80%"} height={14} />
    </View>
  );
};

export default TenantCardSkeleton;

const styles = StyleSheet.create({
  card: {
    backgroundColor: "#F5F6F7",
    padding: 18,
    borderRadius: 8,
    marginBottom: 16,
  },
});